import { useTranslation } from '@utils/i18n/i18n';
import { useEffect } from 'react';

function MetaTags() {
  const { t, lang } = useTranslation();

  useEffect(() => {
    const descriptions = {
      nl: 'Vind alle deelauto’s, deelfietsen en deelsteps in je buurt.',
      fr: 'Trouvez toutes les voitures, vélos et trottinettes partagés près de chez vous.',
      en: 'Find all shared cars, bikes and scooters near you.',
    };

    const locale = `${lang}_BE`;
    const alternateLocales = ['nl_BE', 'fr_BE', 'en_BE'].filter(l => l !== locale);

    const metaTags = {
      'og:title': t('tab_title'),
      'og:type': 'website',
      'og:image': '/meta-img.png',
      'og:url': `https://map.waytogo.be/${lang}/`,
      'og:locale': locale,
      'og:description': descriptions[lang] || descriptions.en,
      'og:site_name': 'Way To Go',
    };

    document.title = t('tab_title');

    Object.entries(metaTags).forEach(([key, value]) => {
      let metaTag = document.querySelector(`meta[property="${key}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', key);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', value);
    });

    document.querySelectorAll('meta[property="og:locale:alternate"]').forEach(tag => tag.remove());

    alternateLocales.forEach((altLocale) => {
      const metaTag = document.createElement('meta');
      metaTag.setAttribute('property', 'og:locale:alternate');
      metaTag.setAttribute('content', altLocale);
      document.head.appendChild(metaTag);
    });
  }, [lang, t]);

  return null;
}

export default MetaTags;